import React, {useState,useEffect} from 'react';
import {Link} from "react-router-dom"
import {FiUserPlus, FiLogIn } from "react-icons/fi"

import { auth } from '../functions/firebaseFunctions'
const ResetForm = () =>{
    const [scsMsg, showScsMsg] = useState(false);
    const [Err, setErr] = useState(null);
    let timeout
    useEffect(()=>{
      return function cleanup() {
        clearTimeout(timeout)
      }
    })
    const reset = async event => {
      event.preventDefault()
      const {email} = event.target
      
      if(email.value){
        auth.sendPasswordResetEmail(email.value).then(function() {
          showScsMsg(true);
          // timeout = setTimeout(()=>{showScsMsg(false),3000})
        }).catch(e=>{
          setErr(e)
        });
      }else{setErr({code:'EmptyEmail',message:'Provide an e-mail address'})}
    
    }
    return (
      <>
      <form onSubmit={reset} className='logForms'>
        <img alt='PartyLivePrototype' src='/Logo.png'
          style={{ width: 300, height: 160, marginTop: 40, marginBottom: 20, alignSelf: 'center' }}
        />
        {scsMsg === true && <div style={{color:'white'}}><p style={{color:'white'}}>Password Reset e-mail was sent to the email address your provided</p></div>}
        {Err && <div style={{color:'red'}}><p style={{color:'red'}}>{Err.message}</p></div>}
        <input className='ProfileInput'
          style={Err && (Err.code === 'EmptyEmail' || Err.code === 'auth/invalid-email' || Err.code === 'auth/user-not-found') 
            ? {borderColor: 'tomato', animation: 'none'} 
            : null}
          placeholder="E-mail" 
          autocompletetype="email"
          autoCapitalize='none'
          name='email'
          maxLength={100}
        />
        <button className='btnYorp' style={{width: '100%'}} type='submit' >
          <p>Reset Password</p>
        </button>
      </form>
      <div style={{display: 'flex', flex: 1, justifyContent: 'center'}}>
        <div  style={{width: '320px'}}>
          <hr style={{borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5}} />
          <nav style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <Link className='RegisterResetButtons' 
                to="/Profile/register"
            >
                <p className='ProfileText'>register</p>
                <FiUserPlus style={{margin: 5, color: 'var(--ltg)',}}/>
            </Link>
            <Link className='RegisterResetButtons'
                to="/Profile/login"
            >
                <p className='ProfileText'>Login</p>
                <FiLogIn style={{margin: 5, color: 'var(--ltg)',}}/>
            </Link>
          </nav>
          <hr style={{borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5}} />
        </div>
       </div>
       </>
    );
  }

export default ResetForm
